import React, { useState } from "react";
import Button, { ButtonType } from "./Assets/Button";
import { NavItem } from "../models/userData.model";
import toast from "react-hot-toast";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: NavItem) => void;
}

const AddNavigationModal: React.FC<Props> = ({ isOpen, onClose, onSubmit }) => {
  const [form, setForm] = useState({
    path: "",
    label: "",
    component: "",
  });

  const handleSubmit = () => {
    if (!form.label.trim() || !form.component.trim()) {
      toast.error("All fields are required");
      return;
    }

    const finalData = {
      label: form.label,
      component: form.component,
      path: `/${form.path}`,
    };

    onSubmit(finalData);
    console.log("submit", finalData);

    onClose();
    setForm({ path: "", label: "", component: "" });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 animate-fadeIn">
        <div className="mb-5 border-b pb-3">
          <h2 className="text-xl font-semibold text-gray-800">
            Add Navigation
          </h2>
          <p className="text-sm text-gray-500">
            Create a new navigation route for the system
          </p>
        </div>

        <div className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Path
            </label>
            <div className="flex items-center border rounded-lg overflow-hidden focus-within:ring-2 focus-within:ring-blue-500">
              <span className="px-3 py-2 bg-gray-100 text-gray-500 text-sm">
                /
              </span>
              <input
                placeholder="e.g. dashboard"
                value={form.path}
                onChange={(e) =>
                  setForm({
                    ...form,
                    path: e.target.value.replace(/^\/+/, ""),
                  })
                }
                className="w-full p-2 outline-none text-sm"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Label
            </label>
            <input
              placeholder="e.g. Dashboard"
              value={form.label}
              onChange={(e) => setForm({ ...form, label: e.target.value })}
              className="w-full p-2 border rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Component
            </label>
            <input
              placeholder="e.g. DashboardPage"
              value={form.component}
              onChange={(e) => setForm({ ...form, component: e.target.value })}
              className="w-full p-2 border rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
          <Button
            type={ButtonType.Cancel}
            onClick={onClose}
            className="text-xs px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-100"
          >
            Cancel
          </Button>
          <Button
            type={ButtonType.Submit}
            onClick={handleSubmit}
            className="text-xs px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
          >
            Add Navigation
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddNavigationModal;
